import { render, staticRenderFns } from "./spaceship.vue?vue&type=template&id=7e471792&scoped=true&"
import script from "./spaceship.vue?vue&type=script&lang=js&"
export * from "./spaceship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e471792",
  null
  
)

export default component.exports